import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import TipoChavePixService from "../../services/TipoChavePixService";
import CrudForm from "../../components/forms/custom/CrudForm";

class FormTipoChavePix extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idTipoChavePix: "",
            nome: ""
        };

        this.state.crud = {
            service: TipoChavePixService,
            labels: {
                title: 'Tipo de Chave Pix',
            },
            urlList: '/LstTipoChavePix',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">
                <InputText label="Código" md={3} value={this.state.model.idTipoChavePix} name="idTipoChavePix" readOnly opcionalLabel={false} />
                <InputText label="Nome da Tipo de Chave Pix" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormTipoChavePix {...props} navigate={navigate} params={params} />
}

export default With